import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RoleMenu, RoleMenuCreate, RoleMenuFilter } from '../data/roleMenu';

export function createRoleMenuService(client: AxiosInstance) {
  return createCrudService<RoleMenu, RoleMenuCreate, RoleMenuFilter>(client, '/RoleMenu', 'roleMenuId');
}

export type RoleMenuService = CrudService<RoleMenu, RoleMenuCreate, RoleMenuFilter>;
